// openEHR BASE model — declarations with no BMM package in the map
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { TYPE_REGISTRY } from "./_shared.ts";
import type { Any } from "./foundation_types/foundation_types.ts";
import { Boolean, Ordered } from "./foundation_types/primitive_types.ts";

/**
 * 8-bit unsigned integer. Retained for compatibility: official BASE 1.3.0
 * working copies no longer list this class (Octet remains).
 */
export class Byte extends Ordered {
  // Lazy type registration - only runs when class is actually used
  static {
    TYPE_REGISTRY.set("BYTE", Byte);
  }

  /**
   * The underlying primitive value.
   */
  value?: number;

  /**
   * Creates a new Byte instance.
   * @param val - The primitive value to wrap
   */
  constructor(val?: number) {
    super();
    if (
      val !== undefined && val !== null &&
      (!Number.isInteger(val) || val < 0 || val > 255)
    ) {
      throw new Error(
        `Byte value must be an integer between 0 and 255, got: ${val}`,
      );
    }
    this.value = val;
  }

  /**
   * Creates a Byte instance from a primitive value.
   * @param val - The primitive value to wrap
   * @returns A new Byte instance
   */
  static from(val?: number): Byte {
    return new Byte(val);
  }

  /**
   * Returns True if current Byte is less than other.
   * @param other - Parameter
   * @returns Result value
   */
  override less_than(other: Ordered): Boolean {
    if (other instanceof Byte) {
      const thisVal = this.value || 0;
      const otherVal = other.value || 0;
      return new Boolean(thisVal < otherVal);
    }
    return new Boolean(false);
  }

  /**
   * Compares this Byte with another for value equality.
   * @param other - The object to compare with
   * @returns true if the values are equal
   */
  override is_equal(other: Any): Boolean {
    if (other instanceof Byte) {
      const thisVal = this.value || 0;
      const otherVal = other.value || 0;
      return new Boolean(thisVal === otherVal);
    }
    return new Boolean(false);
  }
}
